import modelService from '@/services/model'

export default {

  show: (cbOk, cbErr, id) => {
    return modelService.show(cbOk, cbErr, `/users/${id}.json`)
  },

  update: (cbOk, cbErr, instance) => {
    return modelService.update(cbOk, cbErr, instance, `/users/${instance.id}.json`)
  }
}



// WEBPACK FOOTER //
// ./src/services/user.js